export const productSpecificFeedbackOption = 'A Specific Product';
export const questsFeedbackOption = 'Quests (Assignments)';
export const studentExperienceFeedbackOption = 'Student Experience';
export const rosteringFeedbackOption = 'Rostering';
export const reportsFeedbackOption = 'Reports';
export const licensesFeedbackOption = 'Licenses';
export const accountsFeedbackOption = 'Accounts';
export const loginFeedbackOption = 'Logging In';
export const assetFeedbackOption = 'Asset';
export const somethingElseFeedbackOption = 'Something Else';

export const userFeedbackOptions = [
  productSpecificFeedbackOption,
  questsFeedbackOption,
  studentExperienceFeedbackOption,
  rosteringFeedbackOption,
  reportsFeedbackOption,
  licensesFeedbackOption,
  accountsFeedbackOption,
  loginFeedbackOption,
  assetFeedbackOption,
  somethingElseFeedbackOption,
];
